// extracted by mini-css-extract-plugin
export var standaloneTable = "_hl-0";
export var standaloneTableWithBodyFill = "_hl-1";
export var withExtraHeader = "_hl-2";